define('models/AdvantageGroupCollection',['ObjectCollection', 'models/AdvantageGroupModel'],
    function (ObjectCollection, AdvantageGroupModel) {
        //
        // AdvantageGroupCollection
        //
        var AdvantageGroupCollection = ObjectCollection.extend({
            model:AdvantageGroupModel,
        });

        return AdvantageGroupCollection;

    });
